module.exports = __webpack_public_path__ + "img/text_3.63173e6b.png";